export const LOGIN_CONSTANTS = {
  id: 'login',
  title: 'Login',
  username: 'Usuario',
  usernameRequiredMsg: 'Ingrese el nombre de usuario',
  password: 'Contraseña',
  passwordRequiredMsg: 'Ingrese la contraseña',
  continue: 'Ingresar'
};
